type EmailDataPlaceholderSource = {
    placeholdersSubjectList: Compleo.IObject[];
    placeholdersBodyList: Compleo.IObject[];
    placeholdersBodyRequiredList: Compleo.IObject[];
};

export const getFieldValueFromEmailDataResponse = (
    currentFieldValue: Compleo.IObject,
    mainData: Compleo.IObject | undefined,
    emailData: EmailDataPlaceholderSource
) => {
    const placeholderData = {
        attachments_filesDefinition: {
            values: [],
            multiple: true
        },
        arrayPlaceHolderSubject: emailData.placeholdersSubjectList.map(
            (item) => item.value
        ),
        arrayPlaceHolderBody: emailData.placeholdersBodyList.map(
            (item) => item.value
        ),
        arrayPlaceHolderBodyRequired: emailData.placeholdersBodyRequiredList.map(
            (item) => item.value
        )
    };

    if (!mainData?.subject && !mainData?.body) {
        const fieldWithoutOrphanId = { ...currentFieldValue };
        delete fieldWithoutOrphanId.id;
        return {
            ...fieldWithoutOrphanId,
            _tempEmailData: {
                ...(currentFieldValue._tempEmailData || {}),
                body: "",
                subject: "",
                attachments: [],
                ...placeholderData
            }
        };
    }

    return {
        ...currentFieldValue,
        _tempEmailData: {
            body: mainData?.body || "",
            subject: mainData?.subject || "",
            attachments: mainData?.attachments || [],
            ...placeholderData
        }
    };
};
